var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping ID")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.Status == 0 ? 'required' : ''),
      expression: "Status == 0 ? 'required' : '' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingID),
      expression: "ShippingID"
    }],
    ref: "input",
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingID')
    },
    staticStyle: {},
    attrs: {
      "placeholder": "Enter ShippingId / AWB",
      "id": "ShippingID",
      "type": "text",
      "name": "ShippingID"
    },
    domProps: {
      "value": (_vm.ShippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShippingID')),
      expression: "errors.has('form-1.ShippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter ShippingID")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShippingID')),
      expression: "errors.has('ShippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShippingID')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace input-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.getShipmentdetailsbyshippingid
    }
  }, [_vm._v("Show Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])])], 1)])]), _vm._v(" "), (_vm.checkCount == 2) ? _c('div', [_c('p', {
    staticStyle: {
      "margin-left": "10px",
      "color": "red"
    },
    model: {
      value: (_vm.ReturnMessage),
      callback: function($$v) {
        _vm.ReturnMessage = $$v
      },
      expression: "ReturnMessage"
    }
  }, [_vm._v("Error - " + _vm._s(_vm.ReturnMessage))])]) : _vm._e(), _vm._v(" "), (_vm.checkCount == 1) ? _c('div', [_c('legend', [_vm._v("Transaction Details")])]) : _vm._e(), _vm._v(" "), (_vm.checkCount == 1) ? _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered bg-color ",
    staticStyle: {
      "width": "100%",
      "border-width": "5px",
      "border-style": "solid"
    },
    attrs: {
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "border-width": "5px",
      "border-style": "solid"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Shipment Master")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "border-width": "5px",
      "border-style": "solid"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("E-payment Transaction")])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("EPayment Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("EPayment Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Is_EPayment Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("EPayment Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("EPayment Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created DateTime")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Transaction DateTime")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("TransStatus Code")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status Message")])])]), _vm._v(" "), _c('tbody', [(_vm.shipmentData == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shipmentData), function(val, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(val.ShipmentMasterEPaymentType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShipmentMasterEPaymentName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShipmentMasterIsEPaymentMode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.Amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.TransactionEPaymentType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.TransactionEPaymentName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.TransactionDateTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.TransStatusCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.StatusMessage))])])
  })], 2)])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  })], 1) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('legend', [_vm._v("E-Payment Transactions Details For Shipment")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6537c217","hasScoped":true}!./src/views/components/E_PaymentTransactionDetails/ePaymentTransactionsForShipment/ePaymentTransactionsForShipment.component.html
// module id = 1215
// module chunks = 1